module.exports = __webpack_public_path__ + "static/img/11.5308307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/11.png
// module id = d+xP
// module chunks = 0